import type { ClubIntroImageKey } from 'src/enums/club-intro-image';

const clubIntroImages = {
  amMichelIntroClubImage: {
    imagePath: '/fixed-images/meridian-clubs/am_michel.jpg',
    alternateText: 'Am Michel club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  eppendorfIntroClubImage: {
    imagePath: '/fixed-images/meridian-clubs/eppendorf.jpg',
    alternateText: 'Eppendorf club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  barmbekIntroClubImage: {
    imagePath: '/fixed-images/meridian-clubs/barmbek.jpg',
    alternateText: 'Barmbek club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  berlinSpandauIntroClubImage: {
    imagePath: '/fixed-images/meridian-clubs/berlin.jpg',
    alternateText: 'Berlin Spandau club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  frankfurtIntroClubImage: {
    imagePath: '/fixed-images/germany-clubs/frankfurt.jpg',
    alternateText: 'Frankfurt club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  alstertalIntroClubImage: {
    imagePath: '/fixed-images/meridian-clubs/alstertal.jpg',
    alternateText: 'Alstertal club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  kielSophienhofIntroClubImage: {
    imagePath: '/fixed-images/meridian-clubs/kiel_sophienhof.jpg',
    alternateText: 'Kiel Sophienhof club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  wandsbekIntroClubImage: {
    imagePath: '/fixed-images/meridian-clubs/wandsbek.jpg',
    alternateText: 'Wandsbek club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  veigyIntroClubImage: {
    imagePath: '/fixed-images/france-clubs/veigy.jpg',
    alternateText: 'Veigy club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  countryClubGenevaIntroClubImage: {
    imagePath: '/fixed-images/switzerland-clubs/country-club-geneva.jpg',
    alternateText: 'Country Club Geneva club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  uccleIntroClubImage: {
    imagePath: '/fixed-images/belgium-clubs/uccle.jpg',
    alternateText: 'Brussels Uccle club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  antwerpIntroClubImage: {
    imagePath: '/fixed-images/belgium-clubs/antwerp.jpg',
    alternateText: 'Antwerp club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  sterrebeekIntroClubImage: {
    imagePath: '/fixed-images/belgium-clubs/sterrebeek.jpg',
    alternateText: 'Sterrebeek club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  badHomburgIntroClubImage: {
    imagePath: '/fixed-images/germany-clubs/bad-homburg.jpg',
    alternateText: 'Bad Homburg club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  chelseaIntroClubImage: {
    imagePath: '/fixed-images/harbour-clubs/chelsea.jpg',
    alternateText: 'Chelsea club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  nottingHillIntroClubImage: {
    imagePath: '/fixed-images/harbour-clubs/notting-hill.jpg',
    alternateText: 'Notting Hill club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  dublinRiverviewIntroClubImage: {
    imagePath: '/fixed-images/ireland-clubs/dublin-riverview.jpg',
    alternateText: 'Dublin Riverview club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  malaspinaIntroClubImage: {
    imagePath: '/fixed-images/italy-clubs/malaspina.jpg',
    alternateText: 'Milano Malaspina club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  modenaIntroClubImage: {
    imagePath: '/fixed-images/italy-clubs/modena.jpg',
    alternateText: 'Modena club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  rotterdamBlijdorpIntroClubImage: {
    imagePath: '/fixed-images/netherlands-clubs/rotterdam-blijdorp.jpg',
    alternateText: 'Rotterdam Blijdorp club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  amsterdamIntroClubImage: {
    imagePath: '/fixed-images/netherlands-clubs/amsterdam.jpg',
    alternateText: 'Amsterdam club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  capelleIntroClubImage: {
    imagePath: '/fixed-images/netherlands-clubs/capelle.jpg',
    alternateText: 'Capelle club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  rotterdamCentrumIntroClubImage: {
    imagePath: '/fixed-images/netherlands-clubs/rotterdam-centrum.jpg',
    alternateText: 'Rotterdam Centrum club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  utrechtIntroClubImage: {
    imagePath: '/fixed-images/netherlands-clubs/utrecht.jpg',
    alternateText: 'Utrecht club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  eindhovenIntroClubImage: {
    imagePath: '/fixed-images/netherlands-clubs/eindhoven.jpg',
    alternateText: 'Eindhoven club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  turoIntroClubImage: {
    imagePath: '/fixed-images/spain-clubs/turo.jpg',
    alternateText: 'Turo club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  aravacaIntroClubImage: {
    imagePath: '/fixed-images/spain-clubs/aravaca.jpg',
    alternateText: 'Aravaca club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  gavaMarIntroClubImage: {
    imagePath: '/fixed-images/spain-clubs/gava-mar.jpg',
    alternateText: 'Gava Mar club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  malagaIntroClubImage: {
    imagePath: '/fixed-images/spain-clubs/malaga.jpg',
    alternateText: 'Málaga club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  zaragozaIntroClubImage: {
    imagePath: '/fixed-images/spain-clubs/zaragoza.jpg',
    alternateText: 'Zaragoza club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  laFincaIntroClubImage: {
    imagePath: '/fixed-images/spain-clubs/la-finca.jpg',
    alternateText: 'La Finca club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  serranoIntroClubImage: {
    imagePath: '/fixed-images/spain-clubs/serrano.jpg',
    alternateText: 'Serrano club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
  boadillaIntroClubImage: {
    imagePath: '/fixed-images/spain-clubs/boadilla.jpg',
    alternateText: 'Boadilla club intro picture',
    horizontalFocus: 'center',
    leftHighlight: false,
  },
} satisfies Record<ClubIntroImageKey, Queries.ImageDetails>;

export const getClubIntroImage = (
  introImageKey: ClubIntroImageKey | undefined
): Queries.ImageDetails | undefined => {
  if (introImageKey === undefined) {
    return undefined;
  }
  return clubIntroImages[introImageKey];
};
